import { createContext } from 'react';

import { useStore } from 'src/hooks/useStore';
import ApiService, { ApiServiceInterface } from 'src/services/ApiService';
import { ERROR_MESSAGES } from 'src/utils/constants';

interface ApiContextInterface {
  api: ApiServiceInterface
}

export const ApiContext = createContext<ApiContextInterface>({
  api: new ApiService(() => {
    throw new Error(ERROR_MESSAGES.tokenNotProvided);
  }),
});

interface ApiProviderOptions {
  children?: React.ReactNode
}

export const ApiProvider = (props: ApiProviderOptions): JSX.Element => {
  const { children } = props;
  const { authStore } = useStore();

  return (
    <ApiContext.Provider value={{ api: new ApiService(authStore.getWhsAccessToken) }}>{children}</ApiContext.Provider>
  );
};

export default ApiProvider;
